export enum CartPage {
  Cart,
  Adress,
  Payment,
  Order
}
